import { Button } from "pepsico-ds";
import { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { MainCard } from "../../components/common";
import { CampaignSetupContext } from "../../context/CampaignSetupContext";
import { paths } from "../../routes/paths";
import { FeatureToggle, useFeatureToggle } from "../../utils/featureToggle";
import SummaryPage from "./setupPages/SummaryPage";

const CampaignSummaryViewPage = ({ campaignId }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { campaignState } = useContext(CampaignSetupContext);
  const isBonusFlowEnabled = useFeatureToggle(FeatureToggle.isBonusFlowEnabled);
  const onClickBack = () => {
    if (isBonusFlowEnabled && campaignState?.type === "gift_processing") {
      return navigate(`/${paths.campaigns}/${paths.bonus_list}`);
    } else navigate(`/${paths.campaigns}/${paths.campaign_list}`);
  };

  return (
    <div
      className="display-flex flex-direction-column"
      style={{
        gap: "1rem",
        padding: "1rem",
      }}
    >
      {!campaignId && (
        <MainCard styles={{ justifyContent: "space-between" }}>
          <Button
            onClick={() => onClickBack()}
            style={{ flex: 0.5, justifyContent: "flex-start", fontWeight: "bold" }}
            iconLeading="arrow_back"
            size="small"
            variant="primaryInverse"
          >
            Back to Campaign Listing
          </Button>
          <h2 style={{ flex: 1 }}>Campaign Summary</h2>
        </MainCard>
      )}
      <SummaryPage campaignId={campaignId || id} isOnPage={!campaignId} />
    </div>
  );
};

export default CampaignSummaryViewPage;
